import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { UserDataService } from 'src/app/shared/services/user-data.service';
import { BoltMenuItem } from '../bolt-sidenav/bolt-menu-item.model';
import { BoltSidenavService } from '../bolt-sidenav/bolt-sidenav.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  navigationOptions!: BoltMenuItem[];
  userData: any[] = [];
  userRoles: any;
  uid: string | undefined;
  isLoading = true;
  roleId: any;

  constructor(
    private boltSidenavService: BoltSidenavService,
    private firestore: AngularFirestore,
    private userDataService: UserDataService,
    private route: Router
  ) {
    this.uid = this.userDataService.userUID;
  }

  ngOnInit() {
    this.getClientProfile();
    this.loadMenuOptions();
  }

  getClientProfile() {
    this.firestore
      .collection('clientProfile')
      .doc(this.uid)
      .get()
      .subscribe((data: any) => {
        if (data.data()) {
          this.roleId = data.data()?.roleId;
          this.userDataService.setRoleId(this.roleId);
          this.getUserRole(data.data()?.roleId);
        } else this.getEmployeeProfile();
      });
  }

  getEmployeeProfile() {
    this.firestore
      .collection('employeeProfile')
      .doc(this.uid)
      .get()
      .subscribe((data: any) => {
        this.roleId = data.data()?.roleId;
        this.userDataService.setRoleId(this.roleId);
        this.getUserRole(data.data()?.roleId);
      });
  }

  getUserRole(roleId: any) {
    this.firestore
      .collection('Admin')
      .doc(roleId)
      .get()
      .subscribe((data) => {
        this.userRoles = data.data();
        const screens = new Set(this.userRoles.screens);
        let menuOptions: BoltMenuItem[] = [];
        this.navigationOptions.filter((option: BoltMenuItem) => {
          if (option.children && option.children.length > 0) {
            const children = option.children.filter((child: BoltMenuItem) =>
              screens.has(child.title)
            );
            if (children.length > 0) {
              const newOption = { ...option, children };
              if (newOption.children.length > 0) menuOptions.push(newOption);
              return true;
            }
          } else {
            if (screens.has(option.title)) {
              menuOptions.push(option);
              return true;
            }
          }
          return false;
        });

        this.navigationOptions = menuOptions;
        if (this.roleId === 'dietician') {
          this.route.navigate(['/layout/create-diet-plan']);
        } else {
          this.route.navigate(['/layout/dashboard']);
        }
        this.isLoading = false;
      });
  }

  loadMenuOptions() {
    this.navigationOptions = [
      {
        icon: '../../../../../assets/images/dashboards.png',
        label: 'Dashboard',
        route: './dashboard',
        url: '',
        title: 'dashboard',
        disabled: false,
        isOpen: false,
        expandPriority: false,
        hasAccess: false,
      },
      {
        icon: '../../../../../assets/images/plan (1).png',
        label: 'Diet Plan',
        route: undefined,
        url: '',
        title: 'dietPlan',
        disabled: true,
        isOpen: true,
        expandPriority: true,
        hasAccess: false,
        children: [
          {
            icon: '../../../../../assets/images/diet (1).png',
            label: 'Create Diet Plan',
            route: './create-diet-plan',
            url: '',
            title: 'createDietPlan',
            disabled: false,
            isOpen: false,
            expandPriority: false,
            hasAccess: false,
          },
          {
            icon: '../../../../../assets/images/questionnaire.png',
            label: 'Diet Questionnaire',
            route: './diet-questionnaire',
            url: '',
            title: 'dietQuestionnaire',
            disabled: false,
            isOpen: false,
            expandPriority: false,
            hasAccess: false,
          },
        ],
      },
      {
        icon: '../../../../../assets/images/users.png',
        label: 'Client',
        route: undefined,
        url: '',
        title: 'client',
        disabled: true,
        isOpen: true,
        expandPriority: true,
        hasAccess: false,
        children: [
          {
            icon: '../../../../../assets/images/user (2).png',
            label: 'Create Client Profile',
            route: './create-client-profile',
            url: '',
            title: 'createClientProfile',
            disabled: false,
            isOpen: false,
            expandPriority: false,
            hasAccess: false,
          },
          //  {icon: 'local_library', label: 'Diet Questionnaire', route: './diet-questionnaire', url: '', title: 'Diet Questionnaire', disabled: false, isOpen: false, expandPriority: false, hasAccess: false}
        ],
      },
      {
        icon: '../../../../../assets/images/user (2).png',
        label: 'Employee',
        route: undefined,
        url: '',
        title: 'Employee',
        disabled: true,
        isOpen: true,
        expandPriority: true,
        hasAccess: false,
        children: [
          {
            icon: '../../../../../assets/images/users.png',
            label: 'Employee Entry',
            route: './employee-entry',
            url: '',
            title: 'employee-entry',
            disabled: false,
            hasAccess: false,
          },
          // { icon: 'groups', label: 'Employee Details', route: './employee-details', url: '', title: 'Employee Details', disabled: false, hasAccess: false},
        ],
      },
      {
        icon: '../../../../../assets/images/accounting.png',
        label: 'Expenses',
        route: './expense',
        url: '',
        title: 'expenses',
        disabled: false,
        isOpen: false,
        expandPriority: false,
        hasAccess: false,
      },
      {
        icon: '../../../../../assets/images/user (1).png',
        label: 'Admin',
        route: './admin',
        url: '',
        title: 'admin',
        disabled: false,
        isOpen: false,
        expandPriority: false,
        hasAccess: false,
      },
      // {
      //   icon: '../../../../../assets/images/dashboards.png',
      //   label: 'Appointment',
      //   route: '',
      //   url: 'https://6000-firebase-studio-1756609053183.cluster-64pjnskmlbaxowh5lzq6i7v4ra.cloudworkstations.dev',
      //   title: 'appointment',
      //   disabled: false,
      //   isOpen: false,
      //   expandPriority: false,
      //   hasAccess: false,
      // },
    ];
    this.boltSidenavService.emitMenuOptions.next(this.navigationOptions);
  }
}
